import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../../stores";
import { ContentType } from "../../../../models";

const WhatsappApp = ({
  message,
  isMobile,
  contentType,
  meta,
}: {
  message: string;
  isMobile: boolean;
  contentType?: ContentType;
  meta: any;
}) => {
  const { selectedBot } = useStore("bots");

  if (!selectedBot) return null;

  return (
    <form
      style={{ width: isMobile ? "100%" : "32.5%" }}
      className={clsx("whatsapp-app white", {
        "pl-5": !isMobile,
      })}
    >
      <div className="iphone">
        <div className="bar bar--ios bar--user">
          <h4 className="title mb-0 is-5">{selectedBot.name}</h4>
        </div>
        <div className="bar bar--conversation js-conversation">
          <div className="message message--else">
            <h5 className="subtitle is-6">
              <pre className="custom-pre" style={{ overflow: "hidden" }}>
                <RenderContentType
                  message={message}
                  contentType={contentType}
                  meta={meta}
                />
              </pre>
            </h5>
          </div>
        </div>
      </div>
    </form>
  );
};

const RenderContentType = ({
  message,
  contentType,
  meta,
}: {
  message: string;
  contentType?: ContentType;
  meta: any;
}) => {
  if (contentType === "text") {
    return (
      <div>{message || "Hello World, this is a text message from the bot"}</div>
    );
  } else if (contentType === "media") {
    return (
      <div>
        <img
          className="mb-2 has-rounded-corners"
          src={meta?.media || "/images/product-default.jpeg"}
          alt=""
        />
        {message || "Hello World, this is a text message from the bot"}
      </div>
    );
  } else if (contentType === "quick-reply") {
    return (
      <div>
        {message ||
          "Hello World, this is a text message from the bot. Have you used Edna before?"}
        <div className="is-flex is-flex-direction-column mt-2 is-justify-content-space-between">
          {meta?.actions?.map((action: any, index: number) => (
            <button type="button" className="mb-1 button is-small w-100">
              {action.title || index + 1}
            </button>
          ))}
        </div>
      </div>
    );
  } else if (contentType === "cta") {
    return (
      <div>
        {message || "Hello World, this is a text message from the bot"}
        <div className="is-flex is-flex-direction-column mt-2 is-justify-content-space-between">
          {meta?.actions?.map((action: any, index: number) => (
            <button type="button" className="mb-1 button is-small w-100">
              <span className="icon mr-1">
                <i
                  className={`fa fa-${
                    action.type === "phone-number" ? "phone" : "link"
                  }`}
                ></i>
              </span>
              {action.text || index + 1}
            </button>
          ))}
        </div>
      </div>
    );
  } else if (contentType === "list-picker") {
    return (
      <div>
        {message || "Hello World, this is a text message from the bot"}
        <div className="is-flex is-flex-direction-column mt-2 is-justify-content-space-between">
          <button type="button" className="button is-small w-100">
            <span className="icon mr-1">
              <i className="fa fa-list"></i>
            </span>
            {meta?.button || "List Picker"}
          </button>
        </div>
      </div>
    );
  } else if (contentType === "card") {
    return (
      <div>
        <span>
          {message || "Hello World, this is a text message from the bot"}
        </span>
        <br />
        <span className="has-text-grey">{meta?.subtitle || "Subtitle"}</span>
        {meta?.media && (
          <img
            className="mb-2 has-rounded-corners"
            src={meta?.media || "/images/product-default.jpeg"}
            alt=""
          />
        )}
        {meta?.buttonType === "quick-reply" && (
          <div className="is-flex is-flex-direction-column mt-2 is-justify-content-space-between">
            {meta?.actions?.map((action: any, index: number) => (
              <button type="button" className="mb-1 button is-small w-100">
                {action.title || index + 1}
              </button>
            ))}
          </div>
        )}
        {meta?.buttonType === "call-to-action" && (
          <div className="is-flex is-flex-direction-column mt-2 is-justify-content-space-between">
            {meta?.actions?.map((action: any, index: number) => (
              <button type="button" className="mb-1 button is-small w-100">
                <span className="icon mr-1">
                  <i
                    className={`fa fa-${
                      action.type === "phone-number" ? "phone" : "link"
                    }`}
                  ></i>
                </span>
                {action.text || index + 1}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  return null;
};

export default observer(WhatsappApp);
